<div
  class="hidden"
  id="customer-list-payload-box"
  appHeaderPayloadId="customer-list-payload-box"
>
  <ng-template
    [appHasAccess]="[
      Role.CreateCustomer,
      Role.CreateCustomerSelf,
      Role.CreateCustomerCapillary,
      Role.CreateCustomerCapillarySelf,
    ]"
  >
    <app-add-button href="/customers/create"></app-add-button>
  </ng-template>
</div>

<app-table
  [isLoading]="!tableConfig"
  [tableConfig]="tableConfig"
  [hasFilters]="true"
  [hasSort]="showSort"
  [sortOptionGroups]="customerSortOptionGroups"
  (clickFiltersButton)="openFiltersModal()"
></app-table>
